import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Logo from '../../../assets/img/logo.svg';
import LogOutIcon from '../../../assets/img/logout.svg';
import isAdmin from '../../../utils/isAdmin';
import { find } from 'lodash';
import {
  MYCARS_ROUTE,
  RESERVATIONS_ROUTE,
  LOGOUT_ROUTE,
  ADMIN_GENERAL_ROUTE,
  FREE_PLACES_ROUTE,
  PERMANENT_PLACES_ROUTE,
  DEFAULT_ROUTE
} from '../../router/routes';

export default function NavBar() {
  const auth = useSelector((state) => state.auth);
  const isLogged = useSelector((state) => state.auth.jwtToken !== null);
  const [shown, toggle] = useState(false);
  const userId = useSelector((state) => state.auth.id);
  const hasPermanentPlace =
    useSelector((state) =>
      find(state.spots, (spot) => spot.userId === userId)
    ) !== undefined;

  function toggleMenu() {
    toggle(!shown);
  }

  return (
    <nav className="navbar">
      <Link to={DEFAULT_ROUTE} className="navbar-logo">
        <img src={Logo} height="37" width="24" alt="Logo" />
      </Link>

      {isLogged && (
        <button
          type="button"
          className="toggle-menu"
          label="Otevřít menu"
          onClick={toggleMenu}
        >
          <i className="fas fa-bars" />
        </button>
      )}

      {isLogged && (
        <div className={`mobile-menu${shown ? ' opened' : ' closed'}`}>
          <button
            type="button"
            className="close-menu"
            label="Otevřít menu"
            onClick={toggleMenu}
          >
            <i className="fas fa-times" />
          </button>
          <div>
            {isAdmin(auth) && (
              <Link
                to={ADMIN_GENERAL_ROUTE}
                className="topbar__nav-link"
                onClick={toggleMenu}
              >
                Administrace
              </Link>
            )}
            <NavLink
              to={MYCARS_ROUTE}
              className="topbar__nav-link"
              onClick={toggleMenu}
            >
              Moje auta
            </NavLink>
            <NavLink
              to={RESERVATIONS_ROUTE}
              className="topbar__nav-link"
              onClick={toggleMenu}
            >
              Rezervace
            </NavLink>
            <NavLink
              to={FREE_PLACES_ROUTE}
              className="topbar__nav-link"
              onClick={toggleMenu}
            >
              Obsazenost
            </NavLink>
            {hasPermanentPlace && (
              <NavLink
                to={PERMANENT_PLACES_ROUTE}
                className="topbar__nav-link"
                onClick={toggleMenu}
              >
                Stálá místa
              </NavLink>
            )}
            <NavLink
              to={LOGOUT_ROUTE}
              className="topbar__nav-link"
              onClick={toggleMenu}
            >
              Odhlásit se
            </NavLink>
          </div>
        </div>
      )}

      <div className="navbar-links">
        {isLogged && (
          <div>
            {isAdmin(auth) && (
              <Link to={ADMIN_GENERAL_ROUTE} className="topbar__nav-link">
                Administrace
              </Link>
            )}
            <NavLink to={MYCARS_ROUTE} className="topbar__nav-link">
              Moje auta
            </NavLink>
            <NavLink to={RESERVATIONS_ROUTE} className="topbar__nav-link">
              Rezervace
            </NavLink>
            <NavLink to={FREE_PLACES_ROUTE} className="topbar__nav-link">
              Obsazenost
            </NavLink>
            {hasPermanentPlace && (
              <NavLink to={PERMANENT_PLACES_ROUTE} className="topbar__nav-link">
                Stálá místa
              </NavLink>
            )}
          </div>
        )}
      </div>
      <Link to={LOGOUT_ROUTE} className="navbar-logout">
        <img
          src={LogOutIcon}
          width="12"
          height="15"
          alt="Odhlášení"
          title="Odhlásit se"
        />
      </Link>
    </nav>
  );
}
